import SellFormArticle from "./SellFormArticle";
import React from "react";

function SellFormIntro() {
    return (
        <>
            <div className="flex flex-col md:flex-row gap-2 md:gap-4 mb-5">
                <div className="flex flex-col gap-y-2 md:gap-y-4">
                    <SellFormArticle
                        title="Vous envisagez de vendre votre bien immobilier en Suisse romande ?"
                        text="Connaître sa juste valeur est la première étape essentielle. Forts de
                                        notre connaissance approfondie du marché local, notre équipe de FOTI Immobilier
                                        vous offre une estimation gratuite et sans engagement, basée sur une analyse
                                        rigoureuse des prix du marché et des caractéristiques uniques de votre bien."/>
                    <SellFormArticle title="Notre analyse experte du marché local"
                                     text="Notre équipe de FOTI Immobilier analyse en profondeur les
                                                     données du marché immobilier local, les prix des biens similaires
                                                     récemment vendus dans votre secteur, et prend en compte les
                                                     spécificités de votre propriété (état, rénovations, exposition,
                                                     commodités)."/>
                    <SellFormArticle title="Une estimation personnalisée et sans engagement"
                                     text="Suite à notre analyse, nous vous fournirons une estimation
                                                     de la valeur de votre bien, adaptée aux réalités du marché. Cette
                                                     démarche est entièrement gratuite et ne vous engage à rien. C'est
                                                     une première étape pour éclairer votre projet immobilier."/>
                </div>
                <div className="flex flex-col gap-y-2 md:gap-y-4">
                    <SellFormArticle title="Décrivez votre bien en quelques informations clés"
                                     text="Remplissez notre formulaire intuitif en fournissant les
                                                     détails essentiels de votre propriété : type de bien, localisation
                                                     précise, surface habitable, nombre de pièces, et toute autre
                                                     caractéristique pertinente. Plus vous êtes précis, plus notre
                                                     estimation initiale sera affinée."/>
                    <SellFormArticle title="Pourquoi choisir FOTI Immobilier pour votre estimation ?"
                                     text={<ul className="space-y-2">
                                         {["Expertise du marché immobilier local en Suisse romande.",
                                             "Estimation gratuite et sans aucune obligation.",
                                             "Analyse comparative de marché rigoureuse et personnalisée.",
                                             "Gain de temps et informations fiables pour votre projet.",
                                             "Accompagnement par des professionnels de l'immobilier de votre région.",
                                             "Confidentialité et respect de vos informations."].map((text, index) => (
                                             <li key={index}
                                                 className="flex space-x-2 rtl:space-x-reverse items-center">
                                                 <svg className="shrink-0 w-3 h-3 text-primary"
                                                      aria-hidden="true"
                                                      xmlns="http://www.w3.org/2000/svg"
                                                      fill="currentColor"
                                                      viewBox="0 0 20 20">
                                                     <path
                                                         d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z"/>
                                                 </svg>
                                                 <span className="leading-tight">{text}</span>
                                             </li>
                                         ))}
                                     </ul>}/>
                </div>
            </div>
            <p className="text-lg md:text-2xl font-semibold">
                N'attendez plus pour connaître la valeur de votre bien.
                Remplissez dès maintenant notre formulaire d'estimation gratuite et lancez votre projet
                immobilier en toute sérénité !
            </p>
        </>
    );
}

export default SellFormIntro;